// import consts from "@/consts.js";
import Request from './request';
// import store from '@/store.js';



async function fetch(data) {
    return Request('get', "api/qacenter-standard-requests/index", data);
}

async function edit(data) {
    return Request('patch', "api/qacenter-standard-requests/edit", data);
}

async function add(data) {
    return Request('patch', "api/qacenter-standard-requests/add", data);
}

async function del(id) {
    return Request('delete', "api/qacenter-standard-requests/del/" + id);
}



export default {
    fetch, 
    edit,
    add,
    del
};